import React, {useMemo} from 'react';
import {sortChampData} from "../../../function";

const UseMatchRating = ({match,myMatch}) => {

    const aiSorted = useMemo(() => {
        return sortChampData(match?.participants_list, [{value: "ai_score", sortType: false}]);
    }, [match,myMatch]);

    const getRank = useMemo(() => {
        if (Array.isArray(match?.participants_list)) {
            const index = aiSorted.findIndex((data) => data.puu_id === myMatch.puu_id);
            return index + 1;
        }
        return 0;
    }, [match, aiSorted,myMatch]);
    return {
        getRank
    }
};

export default UseMatchRating;